import React, { useState } from "react";
import { Tooltip, Upload, message, Button, Form } from "antd";
import XLSIconComponent from "../../Icons/XLSIconComponent";
import CSVIconComponent from "../../Icons/CSVIconComponent";

function RecipientsMassUploadForm({ actions, form, callback }) {
  const [fileUploaded, setFileUploaded] = useState({
    file: null,
    fileBase64: null,
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    // Validación ligera; no hay campos, solo exigimos fichero
    if (!fileUploaded.fileBase64) {
      return message.error("Debes seleccionar un archivo CSV o Excel.");
    }
    callback(fileUploaded);
  };

  const handleFileToBase64 = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result;
      const cleanBase64 = base64String.split(",")[1];
      message.success("Archivo cargado correctamente.");
      setFileUploaded((prevState) => ({
        ...prevState,
        fileBase64: cleanBase64,
      }));
    };
    reader.onerror = () => {
      message.error("Error al cargar el archivo.");
    };
    reader.readAsDataURL(file);
  };

  const uploadProps = {
    name: "file",
    accept:
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    showUploadList: true,
    fileList: fileUploaded?.file ? [fileUploaded.file] : [],
    beforeUpload: (file) => {
      const isValid =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel" ||
        file.name.toLowerCase().endsWith(".csv");

      if (!isValid) {
        message.error("Solo se permiten archivos CSV o Excel.");
        return Upload.LIST_IGNORE;
      }

      setFileUploaded((prev) => ({
        ...prev,
        file: {
          uid: file.uid,
          name: file.name,
          status: "done",
        },
      }));

      handleFileToBase64(file);
      return false;
    },
    onRemove: () => {
      setFileUploaded({ file: null, fileBase64: null });
    },
    multiple: false,
  };

  const handleCancel = () => {
    setFileUploaded({ file: null, fileBase64: null });
    actions.toggleGenericModal();
  };

  return (
    <div className="RecipientsMassUploadForm">
      <h3>Añadir destinatarios masivamente</h3>
      <div>
        <p>
          Introduzca en un archivo CSV o Excel todos los datos para la carga
          masiva de Destinatarios utilizando las siguientes plantillas de
          ejemplo con los campos necesarios:
        </p>
      </div>

      <div className="export-container">
        <span>Descarga de plantillas de ejemplo:</span>
        <Tooltip title="Excel">
          <a
            href="/documents/Plantilla_CargaMasiva_Destinatarios.xlsx"
            download
          >
            <XLSIconComponent style={{ width: 24, height: 24 }} />
          </a>
        </Tooltip>
        <Tooltip title="CSV">
          <a href="/documents/Plantilla_CargaMasiva_Destinatarios.csv" download>
            <CSVIconComponent style={{ width: 24, height: 24 }} />
          </a>
        </Tooltip>
      </div>

      <Form className="form" onSubmit={handleSubmit}>
        <div className="form-file" style={{ marginBottom: 16 }}>
          <Upload {...uploadProps}>
            <Button icon="upload">Cargar fichero CSV/Excel</Button>
          </Upload>
        </div>

        <div
          className="buttons-container"
          style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}
        >
          <Button type="default" className="cancel-btn" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button
            type="default"
            htmlType="submit"
            className="send-btn"
            onClick={handleSubmit}
          >
            Guardar
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default Form.create()(RecipientsMassUploadForm);
